module.exports = __webpack_public_path__ + "static/media/Character.a69e91a4.png";